import { Icon, IconButton, TextField } from '@material-ui/core';
import React, { useEffect, useRef, useState } from 'react'
import { ChromePicker } from 'react-color';
import './ColorPicker.css';

export default function ColorPicker({
  disabled = false,
  autoFocus = false,
  label = 'Color',
  value = '',
  onChange = () => { },
  onBlur = () => { },
  name = `${Math.round(Math.random() * 100)}`,
}) {
  const [PickerHidden, setPickerHidden] = useState(true);
  const PickerHiddenRef = React.useRef(PickerHidden);
  const TextFieldRef = useRef(null);

  const _setPickerHidden = data => {
    PickerHiddenRef.current = data;
    setPickerHidden(data);
  };

  useEffect(() => {
    window.addEventListener('click', _onDocumentClick);

    return () => {
      window.removeEventListener('click', _onDocumentClick);
    }
    
    // eslint-disable-next-line
  }, []);

  const _onDocumentClick = (event) => {
    if (PickerHiddenRef.current) return;
    const path = (typeof event.composedPath === 'function' ? event.composedPath() : event.path) || [];
    let clickPicker = path.find((ele) => ele && ele.className && typeof ele.className === 'string' && ele.className.search('picker') >= 0);
    if (!clickPicker) _setPickerHidden(true);
  }

  const _onButtonClick = () => {
    _setPickerHidden(false);
  }

  const _onColorChange = (color) => {
    onChange(color.hex.replace(/#/g, ''));
    onBlur();
  }

  const displayHex = value && value.length > 0 ? (value.startsWith('#') ? value : `#${value}`) : '#000000';

  return (
    <div id={`color-picker-${name}`}>
      <div className='color-picker-container' style={{ display: 'flex', justifyContent: 'space-between' }}>
        <TextField
          ref={TextFieldRef}
          disabled={true}
          autoFocus={autoFocus}
          variant="outlined"
          className="form-field"
          type='text'
          label={`${label}`}
          value={value || ''}
        />
        <IconButton style={{ color: displayHex }} onClick={_onButtonClick}>
          <Icon>build</Icon>
        </IconButton>
        {!PickerHidden && (
          <ChromePicker
            color={displayHex}
            onChangeComplete={_onColorChange}
          />
        )}
      </div>
    </div>
  )
}
